import trim from 'lodash/trim';
import leftPad from 'lodash/padStart';
import isString from 'lodash/isString';
import map from 'lodash/map';



const MONTHS = [
  __('Jan'), __('Feb'), __('Mar'), __('Apr'),
  __('May'), __('Jun'), __('Jul'), __('Aug'),
  __('Sep'), __('Oct'), __('Nov'), __('Dec')
];

const MONTHS_SM = [
  __('sm@_jan'), __('sm@_feb'), __('sm@_mar'), __('sm@_apr'),
  __('sm@_may'), __('sm@_jun'), __('sm@_jul'), __('sm@_aug'),
  __('sm@_sep'), __('sm@_oct'), __('sm@_nov'), __('sm@_dec')
];

const UNIT_LOCALIZATION_KEY = {
  'mb': 'sm@_mb'
};

const localizeSizeUnits = (units) => {
  const localizationKey = UNIT_LOCALIZATION_KEY[units.toLowerCase()];

  // TODO: Remove when all units localized
  if (!localizationKey) {
    return units;
  }

  return __(localizationKey);
};

/**
 * @param {String} dateStr
 * @param {String[]} format
 * @returns {String} formatted number with KB/MB/etc
 * */
export const formatDate = (dateStr, format = [ 'dd', ' ', 'mmm', ' ', 'yyyy' ]) => {
  const date = new Date(trim(dateStr));

  return format.map((str) => {
    if (str === 'yyyy') {
      return date.getFullYear();
    }

    if (str === 'dd') {
      return leftPad(date.getDate(), 2, '0');
    }

    if (str === 'mm') {
      return leftPad(date.getMonth() + 1, 2, '0');
    }

    if (str === 'mmm') {
      return MONTHS[date.getMonth()];
    }

    return str;
  }).join('');
};


// TODO: need rename to formatDate
export const formatDateSM = (dateStr, format = [ 'dd', ' ', 'mmm', ' ', 'yyyy' ]) => {
  const date = new Date(trim(dateStr));

  return format.map((str) => {
    if (str === 'yyyy') {
      return date.getFullYear();
    }

    if (str === 'yy') {
      return date.getFullYear() % 100;
    }

    if (str === 'dd') {
      return leftPad(date.getDate(), 2, '0');
    }

    if (str === 'mm') {
      return leftPad(date.getMonth() + 1, 2, '0');
    }

    if (str === 'mmm') {
      return MONTHS_SM[date.getMonth()];
    }

    return str;
  }).join('');
};

/**
 * @param {Number} bytes
 * @param {Number} zeroCount
 * @param {Boolean} si
 * @returns {String} formatted number with KB/MB/etc
 * */
export const mkFileSize = (bytes, zeroCount = 1, si = true) => {
  const thresh = si ? 1000 : 1024;

  bytes = parseInt(String(bytes), 10);

  if (!bytes || isNaN(bytes)) {
    return null;
  }

  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }

  const units = si ? [ 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB' ] : [ 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB' ];
  let unit = -1;

  do {
    bytes /= thresh;
    ++unit;
  } while (Math.abs(bytes) >= thresh && unit < units.length - 1);

  return `${bytes.toFixed(zeroCount)} ${localizeSizeUnits(units[unit])}`;
};

/**
 * @param {Function|String} iterator
 * @returns {String} markup
 * */
const wrapStrIterator = (iterator) => {
  if (!isString(iterator)) {
    return iterator;
  }

  return (v, i) => iterator.replace(/\$\{\s*value\s*}/gi, v).replace(/\$\{\s*index\s*}/gi, i);
};

/**
 * @param {Array} items
 * @param {Function|String} iterator
 * @param {String} separator
 * @returns {String} markup
 * */
export const smap = (items, iterator, separator = '') =>
  map(items, wrapStrIterator(iterator)).join(separator);



export const formatNumber = (number, accuracy = 0, sep = ',', point = '.') => {
  accuracy = Number(accuracy) || 0;
  number = Number(number) || 0;

  const sigh = number < 0 ? '-' : '';

  number = Math.abs(number).toFixed(accuracy);

  const beforeDot = String(parseInt(number, 10));
  const i = beforeDot.length > 3 ? beforeDot.length % 3 : 0;
  const intPart = (i ? beforeDot.substr(0, i) + sep : '') + beforeDot.substr(i).replace(/(\d{3})(?=\d)/g, `$1${sep}`);
  const floatPartWithDot = (accuracy ? point + Math.abs(number - beforeDot).toFixed(accuracy).slice(2) : '');

  return sigh + intPart + floatPartWithDot;
};



export const unit = (number, hasFullText = false) => {
  const fullTextList = [ '', __('sm@_Thousand'), __('sm@_Million'), __('sm@_Billion') ];
  const textList = [ '', __('sm@_K'), __('sm@_M'), __('sm@_B') ];

  if (!number || !String(number).length || String(number).length < 3) {
    return '';
  }

  const _number = formatNumber(number).split(/,/g);

  return !hasFullText ? textList[_number.length - 1] : fullTextList[_number.length - 1];
};



const shortRounding = (num, step) => num < step ? 1 : Math.floor(num / step) * step;



export const shortNumber = (number, params = { withDecimal: false, rounded: false }) => {
  const _number = formatNumber(number);

  if (_number.length <= 3) {
    return _number;
  }

  let result = _number.split(/,/g)[0];
  const decimal = Number(_number.split(/,/g)[1][0]);

  if (params.rounded) {
    const stepValue = 5;
    const resultLength = result.length;
    const numFactor = shortRounding(Number(String(number).charAt(0)), stepValue);

    result = Math.pow(10, (resultLength - 1)) * numFactor;
  }

  if (params.withDecimal && decimal !== 0) {
    result = `${result}.${decimal}`;
  }

  return result;
};



export const addIndexes = (offsetIndex = 0) => (item, index) => ({ $index: (index + offsetIndex), ...item });

export const addIds = (item, index) => ({ $id: index, ...item });



// WEBPACK FOOTER //
// ./src/lib/utils.js